export const SITE_ID__RIVCASH = 1;
export const SITE_ID__IXCASH = 50;
export const SITE_ID__ONLYFEETCASH = 56;

export const forumSiteIds = [SITE_ID__RIVCASH, SITE_ID__IXCASH];
